import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/morentouxiang.png'
import _imports_1 from '@/assets/icon/geren.png'
import _imports_2 from '@/assets/icon/qiye.png'
import _imports_3 from '@/assets/icon/weirenzheng.png'
import _imports_4 from '@/assets/image/homeclb.png'
import _imports_5 from '../../assets/image/我的订单.png'
import _imports_6 from '../../assets/image/作品管理.png'
import _imports_7 from '../../assets/image/我的账户.png'
import _imports_8 from '../../assets/image/我的收藏.png'
import _imports_9 from '../../assets/image/我的足迹.png'
import _imports_10 from '../../assets/image/使用指南.png'


const _withScopeId = n => (_pushScopeId("data-v-083bb566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "Rotation" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "container tankuang"
}
const _hoisted_6 = {
  class: "left",
  style: {"outline":"none"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "自动化设计方案", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "one-img",
  src: "https://image.sjyuan.net.cn/img/sjy/share/indextz.png"
}, null, -1))
const _hoisted_9 = { class: "second" }
const _hoisted_10 = { class: "onemenu" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "list" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "list" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "list" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = { class: "list" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "list" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = { class: "list" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "list" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "list" }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = { class: "list" }
const _hoisted_29 = { class: "text" }
const _hoisted_30 = { class: "list" }
const _hoisted_31 = { class: "text" }
const _hoisted_32 = { class: "list" }
const _hoisted_33 = { class: "text" }
const _hoisted_34 = { class: "list" }
const _hoisted_35 = { class: "text" }
const _hoisted_36 = { class: "list" }
const _hoisted_37 = { class: "text" }
const _hoisted_38 = { class: "list" }
const _hoisted_39 = { class: "text" }
const _hoisted_40 = { class: "list" }
const _hoisted_41 = { class: "text" }
const _hoisted_42 = { class: "list" }
const _hoisted_43 = { class: "text" }
const _hoisted_44 = { class: "list" }
const _hoisted_45 = { class: "text" }
const _hoisted_46 = { class: "list" }
const _hoisted_47 = { class: "text" }
const _hoisted_48 = { class: "list" }
const _hoisted_49 = { class: "text" }
const _hoisted_50 = { class: "list" }
const _hoisted_51 = { class: "text" }
const _hoisted_52 = { class: "list" }
const _hoisted_53 = { class: "text" }
const _hoisted_54 = { class: "list" }
const _hoisted_55 = { class: "text" }
const _hoisted_56 = { class: "list" }
const _hoisted_57 = { class: "text" }
const _hoisted_58 = { class: "list" }
const _hoisted_59 = { class: "text" }
const _hoisted_60 = { class: "list" }
const _hoisted_61 = { class: "text" }
const _hoisted_62 = { class: "list" }
const _hoisted_63 = { class: "text" }
const _hoisted_64 = { class: "list" }
const _hoisted_65 = { class: "text" }
const _hoisted_66 = { class: "list" }
const _hoisted_67 = { class: "text" }
const _hoisted_68 = { class: "list" }
const _hoisted_69 = { class: "text" }
const _hoisted_70 = { class: "list" }
const _hoisted_71 = { class: "text" }
const _hoisted_72 = { class: "list" }
const _hoisted_73 = { class: "text" }
const _hoisted_74 = { class: "list" }
const _hoisted_75 = { class: "text" }
const _hoisted_76 = { class: "list" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "机械原理动画", -1))
const _hoisted_78 = { class: "second" }
const _hoisted_79 = { class: "onemenu2" }
const _hoisted_80 = { class: "text" }
const _hoisted_81 = { class: "list" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "自动化知识学习区", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "one-img",
  src: "https://image.sjyuan.net.cn/img/sjy/share/indextz.png"
}, null, -1))
const _hoisted_84 = { class: "second" }
const _hoisted_85 = { class: "onemenu3" }
const _hoisted_86 = { class: "text" }
const _hoisted_87 = { class: "list" }
const _hoisted_88 = { class: "text" }
const _hoisted_89 = { class: "list" }
const _hoisted_90 = { class: "text" }
const _hoisted_91 = { class: "list" }
const _hoisted_92 = { class: "text" }
const _hoisted_93 = { class: "list" }
const _hoisted_94 = { class: "text" }
const _hoisted_95 = { class: "list" }
const _hoisted_96 = { class: "text" }
const _hoisted_97 = { class: "list" }
const _hoisted_98 = { class: "text" }
const _hoisted_99 = { class: "list" }
const _hoisted_100 = { class: "text" }
const _hoisted_101 = { class: "list" }
const _hoisted_102 = { class: "text" }
const _hoisted_103 = { class: "list" }
const _hoisted_104 = { class: "text" }
const _hoisted_105 = { class: "list" }
const _hoisted_106 = { class: "text" }
const _hoisted_107 = { class: "list" }
const _hoisted_108 = { class: "text" }
const _hoisted_109 = { class: "list" }
const _hoisted_110 = { class: "text" }
const _hoisted_111 = { class: "list" }
const _hoisted_112 = { class: "text" }
const _hoisted_113 = { class: "list" }
const _hoisted_114 = { class: "text" }
const _hoisted_115 = { class: "list" }
const _hoisted_116 = { class: "text" }
const _hoisted_117 = { class: "list" }
const _hoisted_118 = { class: "text" }
const _hoisted_119 = { class: "list" }
const _hoisted_120 = { class: "text" }
const _hoisted_121 = { class: "list" }
const _hoisted_122 = { class: "text" }
const _hoisted_123 = { class: "list" }
const _hoisted_124 = { class: "text" }
const _hoisted_125 = { class: "list" }
const _hoisted_126 = { class: "text" }
const _hoisted_127 = { class: "list" }
const _hoisted_128 = { class: "text" }
const _hoisted_129 = { class: "list" }
const _hoisted_130 = { class: "text" }
const _hoisted_131 = { class: "list" }
const _hoisted_132 = { class: "text" }
const _hoisted_133 = { class: "list" }
const _hoisted_134 = { class: "text" }
const _hoisted_135 = { class: "list" }
const _hoisted_136 = { class: "text" }
const _hoisted_137 = { class: "list" }
const _hoisted_138 = { class: "text" }
const _hoisted_139 = { class: "list" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "减速机", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电动机和控制器", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "工业机器人", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "气动和液压", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "控制系统", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "机器视觉系统", -1))
const _hoisted_146 = [
  _hoisted_140,
  _hoisted_141,
  _hoisted_142,
  _hoisted_143,
  _hoisted_144,
  _hoisted_145
]
const _hoisted_147 = { class: "onemenu4" }
const _hoisted_148 = { class: "text" }
const _hoisted_149 = ["onClick"]
const _hoisted_150 = { class: "list" }
const _hoisted_151 = ["onClick"]
const _hoisted_152 = { class: "right" }
const _hoisted_153 = {
  key: 0,
  class: "one"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "welcome" }, "Hi, 欢迎来到设纪元", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login" }, "登录", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register" }, "注册", -1))
const _hoisted_158 = {
  key: 1,
  class: "ones"
}
const _hoisted_159 = ["src"]
const _hoisted_160 = { class: "name" }
const _hoisted_161 = {
  key: 0,
  class: "names"
}
const _hoisted_162 = { key: 0 }
const _hoisted_163 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_164 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_165 = { class: "vips" }
const _hoisted_166 = ["src"]
const _hoisted_167 = {
  key: 0,
  class: "novip"
}
const _hoisted_168 = { class: "money" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { class: "work" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "作品", -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upright" }, null, -1))
const _hoisted_175 = { class: "guanzhu" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "关注", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upright" }, null, -1))
const _hoisted_178 = { class: "fans" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "粉丝", -1))
const _hoisted_180 = { class: "list" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的订单")
], -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "作品中心")
], -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的账户")
], -1))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的收藏")
], -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的足迹")
], -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "新手指南")
], -1))
const _hoisted_187 = { class: "viprecord" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "个人认证")
], -1))
const _hoisted_189 = { class: "record" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 个人认证后，您可以上传作品，对您在设纪元的收益进行提现，进一步保护您的账户安全，防止被盗号。 ", -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "routines" }, "去认证", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Video = _resolveComponent("Video")!
  const _component_Scheme = _resolveComponent("Scheme")!
  const _component_Animation = _resolveComponent("Animation")!
  const _component_Free = _resolveComponent("Free")!
  const _component_Beijian = _resolveComponent("Beijian")!
  const _component_Supply = _resolveComponent("Supply")!
  const _component_html_footer = _resolveComponent("html-footer")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_home_head),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "clickbox",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goSkip && _ctx.goSkip(...args)))
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_carousel, {
            interval: 5000,
            onChange: _ctx.changelist,
            arrow: "never"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
                return _createVNode(_component_el_carousel_item, {
                  key: item,
                  style: {"height":"517px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }, 8, ["onChange"])
        ]),
        (_ctx.arr1 && _ctx.arr1.datas['自动化设计方案'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["one", { 'one-active': _ctx.state == 0 }])
                }, [
                  _createVNode(_component_router_link, { to: {
								name: 'goods-class',
							} }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[0].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[0].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[1].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[1].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[2].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[2].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[3].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[3].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[4].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[4].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[5].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[5].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.自动化设计方案[0].names,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[0].names), 1),
                                _createElementVNode("div", _hoisted_12, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[0]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[1].names), 1),
                                _createElementVNode("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[1]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[2].names), 1),
                                _createElementVNode("div", _hoisted_16, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[2]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[3].names), 1),
                                _createElementVNode("div", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[3]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[4].names), 1),
                                _createElementVNode("div", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[4]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.自动化设计方案[1].names,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[1].son[0].names), 1),
                                _createElementVNode("div", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[1].son[0]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[1].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[1].names), 1),
                                _createElementVNode("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[1].son[1]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[1].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[2].names), 1),
                                _createElementVNode("div", _hoisted_26, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[2]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[3].names), 1),
                                _createElementVNode("div", _hoisted_28, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[3]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[4].names), 1),
                                _createElementVNode("div", _hoisted_30, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[4]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.自动化设计方案[2].names
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[0].names), 1),
                              _createElementVNode("div", _hoisted_32, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[1].names), 1),
                              _createElementVNode("div", _hoisted_34, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[2].names), 1),
                              _createElementVNode("div", _hoisted_36, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[3].names), 1),
                              _createElementVNode("div", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[4].names), 1),
                              _createElementVNode("div", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.自动化设计方案[3].names,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[0].names), 1),
                              _createElementVNode("div", _hoisted_42, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[1].names), 1),
                              _createElementVNode("div", _hoisted_44, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[2].names), 1),
                              _createElementVNode("div", _hoisted_46, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[3].names), 1),
                              _createElementVNode("div", _hoisted_48, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[4].names), 1),
                              _createElementVNode("div", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[5].names), 1),
                              _createElementVNode("div", _hoisted_52, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[5].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.自动化设计方案[4].names,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[0].names), 1),
                              _createElementVNode("div", _hoisted_54, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[1].names), 1),
                              _createElementVNode("div", _hoisted_56, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[2].names), 1),
                              _createElementVNode("div", _hoisted_58, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[3].names), 1),
                              _createElementVNode("div", _hoisted_60, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[4].names), 1),
                              _createElementVNode("div", _hoisted_62, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[5].names), 1),
                              _createElementVNode("div", _hoisted_64, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[5].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.自动化设计方案[5].names,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[0].names), 1),
                              _createElementVNode("div", _hoisted_66, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[1].names), 1),
                              _createElementVNode("div", _hoisted_68, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[2].names), 1),
                              _createElementVNode("div", _hoisted_70, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[3].names), 1),
                              _createElementVNode("div", _hoisted_72, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[4].names), 1),
                              _createElementVNode("div", _hoisted_74, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[5].names), 1),
                              _createElementVNode("div", _hoisted_76, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[5].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'one-active': _ctx.state == 1 }, "two"])
                }, [
                  _createVNode(_component_router_link, {
                    to: {
								name: 'video',
							},
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_77
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.机械原理动画, (item, index) => {
                      return (_openBlock(), _createElementBlock("p", null, [
                        _createVNode(_component_router_link, {
                          to: {
										name: 'video',
										params: {
											id: index + 1,
										},
									}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.机械原理动画, (classitem, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createElementVNode("h2", null, _toDisplayString(classitem.name), 1),
                            _createElementVNode("div", _hoisted_81, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classitem.son, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
														name: 'video-class',
														params: {
															cid: classitem.cid,
															aid: item.aid,
														},
													}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["three", { 'one-active': _ctx.state == 2 }])
                }, [
                  _createVNode(_component_router_link, { to: {
								name: 'free',
							} }, {
                    default: _withCtx(() => [
                      _hoisted_82,
                      _hoisted_83
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_84, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区, (item, index) => {
                      return (_openBlock(), _createElementBlock("p", null, [
                        _createVNode(_component_router_link, {
                          to: {
											name: 'free',
											params: {
												cid: item.id,
											},
										}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.免费专区[0].name,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[0].name), 1),
                                _createElementVNode("div", _hoisted_87, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[0].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[1].name), 1),
                                _createElementVNode("div", _hoisted_89, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[1].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[2].name), 1),
                                _createElementVNode("div", _hoisted_91, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[2].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[3].name), 1),
                                _createElementVNode("div", _hoisted_93, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[3].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.免费专区[1].name,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[0].name), 1),
                                _createElementVNode("div", _hoisted_95, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[0].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[1].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[1].name), 1),
                                _createElementVNode("div", _hoisted_97, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[1].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[1].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_98, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[2].name), 1),
                                _createElementVNode("div", _hoisted_99, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[2].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[1].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_100, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[3].name), 1),
                                _createElementVNode("div", _hoisted_101, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[3].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[1].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[4].name), 1),
                                _createElementVNode("div", _hoisted_103, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[4].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[1].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.免费专区[2].name,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_104, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[0].name), 1),
                                _createElementVNode("div", _hoisted_105, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[0].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[2].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[1].name), 1),
                                _createElementVNode("div", _hoisted_107, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[1].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[2].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_108, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[2].name), 1),
                                _createElementVNode("div", _hoisted_109, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[2].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[2].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_110, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[3].name), 1),
                                _createElementVNode("div", _hoisted_111, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[3].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[2].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.免费专区[3].name,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[3].son[0].name), 1),
                              _createElementVNode("div", _hoisted_113, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[3].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[3].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[3].son[1].name), 1),
                              _createElementVNode("div", _hoisted_115, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[3].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[3].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[3].son[2].name), 1),
                              _createElementVNode("div", _hoisted_117, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[3].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[3].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.免费专区[4].name,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[4].son[0].name), 1),
                              _createElementVNode("div", _hoisted_119, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[4].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[4].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[4].son[1].name), 1),
                              _createElementVNode("div", _hoisted_121, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[4].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[4].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_122, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[4].son[2].name), 1),
                              _createElementVNode("div", _hoisted_123, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[4].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[4].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.免费专区[5].name,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_124, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[0].name), 1),
                              _createElementVNode("div", _hoisted_125, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[1].name), 1),
                              _createElementVNode("div", _hoisted_127, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[2].name), 1),
                              _createElementVNode("div", _hoisted_129, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_130, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[3].name), 1),
                              _createElementVNode("div", _hoisted_131, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.免费专区[6].name,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[0].name), 1),
                              _createElementVNode("div", _hoisted_133, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_134, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[1].name), 1),
                              _createElementVNode("div", _hoisted_135, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_136, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[2].name), 1),
                              _createElementVNode("div", _hoisted_137, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[3].name), 1),
                              _createElementVNode("div", _hoisted_139, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["four", { 'one-active': _ctx.state == 3 }])
                }, [
                  _createElementVNode("h3", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoMovibot('')))
                  }, "工业自动化设备供应链"),
                  _createElementVNode("div", {
                    class: "second",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotoMovibot('')))
                  }, _hoisted_146),
                  _createElementVNode("div", _hoisted_147, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movibotClass[0].list, (movibot, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_148, [
                            _createElementVNode("h2", {
                              onClick: ($event: any) => (_ctx.gotoMovibot(movibot.url))
                            }, _toDisplayString(movibot.name), 9, _hoisted_149),
                            _createElementVNode("div", _hoisted_150, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movibot.list, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  onClick: ($event: any) => (_ctx.gotoMovibot(item.url))
                                }, _toDisplayString(item.name), 9, _hoisted_151))
                              }), 256))
                            ])
                          ]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_152, [
                (_ctx.showName == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                      _hoisted_154,
                      _hoisted_155,
                      _createVNode(_component_router_link, { to: "/login" }, {
                        default: _withCtx(() => [
                          _hoisted_156
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: "/register" }, {
                        default: _withCtx(() => [
                          _hoisted_157
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                      _createVNode(_component_router_link, { to: "user" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.getImgUrl(_ctx.userInfo.portrait),
                            alt: "",
                            class: "photo"
                          }, null, 8, _hoisted_159)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_160, [
                        (_ctx.userInfor.datas.identification)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                              _createVNode(_component_router_link, { to: "user" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.userInfor.datas.username), 1),
                                  (
											_ctx.userInfor.datas.username == null ||
											_ctx.userInfor.datas.username == ''
										)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_ctx.userInfor.datas.mobile), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              (
										_ctx.userInfor.datas.identification == 3 &&
										_ctx.userInfor.datas.company_id == null
									)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_163))
                                : _createCommentVNode("", true),
                              (_ctx.userInfor.datas.company_id != null)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_164))
                                : _createCommentVNode("", true),
                              (
										_ctx.userInfor.datas.company_id == null &&
										_ctx.userInfor.datas.identification != 3
									)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 2,
                                    src: _imports_3,
                                    alt: "",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDialogVisibles())),
                                    style: {"cursor":"pointer"}
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_router_link, { to: "user/myvip" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_165, [
                            (_ctx.vipInfor.data.homeimgurl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.vipInfor.data.homeimgurl,
                                  alt: "",
                                  class: "vip"
                                }, null, 8, _hoisted_166))
                              : _createCommentVNode("", true),
                            (_ctx.isVip)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 1,
                                  class: "vip-title",
                                  style: _normalizeStyle([{"text-align":"center","margin":"10px 0"}, { color: _ctx.vipInfor.data.homecolor }])
                                }, _toDisplayString(_ctx.userInfo.vipInfo.vipTitle), 5))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.isVip)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_167, "开通会员全场商品八折优惠"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: "user/myaccount" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_168, [
                            _hoisted_169,
                            (_ctx.userInfor.datas.pid == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_170, _toDisplayString(_ctx.a + Number(_ctx.userInfor.datas.gear)), 1))
                              : _createCommentVNode("", true),
                            (_ctx.userInfor.datas.pid != 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_171, _toDisplayString(_ctx.a + Number(_ctx.fatherInformation.datas.gear)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        class: "number",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goUser && _ctx.goUser(...args)))
                      }, [
                        _createElementVNode("div", _hoisted_172, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.fansInfor.datas.works), 1),
                          _hoisted_173
                        ]),
                        _hoisted_174,
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.fansInfor.datas.follows), 1),
                          _hoisted_176
                        ]),
                        _hoisted_177,
                        _createElementVNode("div", _hoisted_178, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.userInfor.datas.fans), 1),
                          _hoisted_179
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "routine",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.loginOut && _ctx.loginOut(...args)))
                      }, "退出登录")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_180, [
                  _createVNode(_component_router_link, { to: "/user/myorder" }, {
                    default: _withCtx(() => [
                      _hoisted_181
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/works" }, {
                    default: _withCtx(() => [
                      _hoisted_182
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/myaccount" }, {
                    default: _withCtx(() => [
                      _hoisted_183
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/project" }, {
                    default: _withCtx(() => [
                      _hoisted_184
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/myfootmark" }, {
                    default: _withCtx(() => [
                      _hoisted_185
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'guidance' } }, {
                    default: _withCtx(() => [
                      _hoisted_186
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Video),
      _createVNode(_component_Scheme),
      _createVNode(_component_Animation),
      _createVNode(_component_Free),
      _createVNode(_component_Beijian),
      _createVNode(_component_Supply),
      _createVNode(_component_html_footer)
    ]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRefs",
      dialogwidth: "580px",
      class: "tongzhi"
    }, {
      header: _withCtx(() => []),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_187, [
          _hoisted_188,
          _createElementVNode("div", _hoisted_189, [
            _hoisted_190,
            _createElementVNode("button", {
              class: "routine",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.mcloses()))
            }, "取消"),
            _createVNode(_component_router_link, { to: "user/selfverify" }, {
              default: _withCtx(() => [
                _hoisted_191
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}